import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Historial de pedidos',
  labels: {
    dummy_order: 'Pedido de prueba',
    orders_number: 'Número de pedidos ({{count}})',
    revenue: 'Ingresos: {{amount}}',
    tips: 'Propinas: {{amount}}',
    cash_sales: ' ({{amount}} en efectivo)',
    refunds: 'Reembolsos: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Recogida',
    [OrderMethod.Delivery]: 'Entrega',
    [OrderMethod.OnSite]: 'Pedido en mesa',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'En curso',
    [OrderFulfillmentStatus.Reviewed]: 'En curso',
    [OrderFulfillmentStatus.Accepted]: 'En curso',
    [OrderFulfillmentStatus.Preparing]: 'En curso',
    [OrderFulfillmentStatus.Ready]: 'En curso',
    [OrderFulfillmentStatus.OnDelivery]: 'En curso',
    [OrderFulfillmentStatus.Picked]: 'Completado',
    [OrderFulfillmentStatus.Rejected]: 'Rechazado',
  },
  payment_methods: {
    invoice: 'Factura',
    cash: 'Efectivo',
    online: 'Método en línea',
  },
  filters: {
    all: 'Todos',
  },
  fields: {
    order_placed: 'Pedido realizado',
    order_number: '#',
    customer: 'Cliente',
    payment_method: 'Método de pago',
    method: 'Tipo',
    status: 'Estado',
    total: 'Total',
  },
  buttons: {
    print: 'Imprimir',
    create_test_order: 'Crear pedido de prueba',
  },
  toasts: {
    failed_to_fetch_orders: 'Error al cargar los datos. Pulsa el icono «actualizar» o inténtalo de nuevo en 1 minuto.',
    something_went_wrong: 'Algo salió mal, inténtalo de nuevo.',
    failed_to_create_test_order: 'Error al crear el pedido de prueba',
    test_order_created: 'Pedido de prueba creado',
  },
};
